import React, { useRef } from "react";

import Box from "./Box";
import { CONDITION_FILTER_TYPE } from "../core/constants";
import ItemCondition from "./ItemCondition";
import PropTypes from "prop-types";
import Toggle from "./Toggle";
import { useHovered } from "../core/hooks";
import { useListingsContext } from "./ListingsContext";

function ConditionToggle({ option, showTooltip }) {
  const ref = useRef(null);
  const hovered = useHovered(ref);
  const { setFilter, activeFilters } = useListingsContext();
  const activeFiltersForType = activeFilters.find((filter) => {
    return filter.type === CONDITION_FILTER_TYPE;
  }) || { options: [] };
  const active =
    typeof activeFiltersForType.options.find((activeOption) => {
      return activeOption.label === option.label;
    }) !== "undefined";

  return (
    <Box
      ref={ref}
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <ItemCondition
        condition={option.label}
        showTooltip={showTooltip}
        tooltipActive={hovered}
      />
      <Box display="flex" alignItems="center" pl="10px">
        <Toggle
          active={active}
          onClick={() => {
            setFilter(CONDITION_FILTER_TYPE, option);
          }}
          ariaLabel={`Filter by ${option.label}`}
        />
      </Box>
    </Box>
  );
}

export default ConditionToggle;

ConditionToggle.propTypes = {
  option: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
  showTooltip: PropTypes.bool,
};
